// src/components/common/EmptyState.js
import React from 'react';
import { Box, Typography, Button, Paper } from '@mui/material';
import {
  Inbox as InboxIcon,
  Person as PersonIcon,
  FitnessCenter as ExerciseIcon,
  Business as BusinessIcon,
  AccountCircle as UserIcon,
  Description as ReportIcon,
  Event as EventIcon,
} from '@mui/icons-material';

const EmptyState = ({ 
  type = 'default',
  title,
  message,
  actionLabel,
  onAction,
  icon: CustomIcon,
}) => {
  // Map types to icons - using only icons that exist
  const iconMap = {
    personnel: PersonIcon,
    users: UserIcon,
    exercises: ExerciseIcon,
    commands: BusinessIcon,
    reports: ReportIcon,
    events: EventIcon,
    default: InboxIcon,
  };

  const IconComponent = CustomIcon || iconMap[type] || iconMap.default;

  return (
    <Paper
      sx={{
        p: 6,
        textAlign: 'center',
        backgroundColor: 'background.paper',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 2,
        }}
      >
        <IconComponent
          sx={{
            fontSize: 64,
            color: 'text.disabled',
          }}
        />
        <Typography variant="h6" color="text.secondary">
          {title || 'No Data Available'}
        </Typography>
        {message && (
          <Typography variant="body2" color="text.secondary" sx={{ maxWidth: 400 }}>
            {message}
          </Typography>
        )}
        {actionLabel && onAction && (
          <Button
            variant="contained"
            onClick={onAction}
            sx={{ mt: 2 }}
          >
            {actionLabel}
          </Button>
        )}
      </Box>
    </Paper>
  );
};

export default EmptyState;